import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { useController } from 'react-hook-form'
import { InputGroup, Slider } from '@wmgtech/legato'

import { isRequired } from 'shared/utils/form'

import { FormSliderProps } from './FormSlider.props'

const FormSlider: FC<FormSliderProps> = ({
  control,
  fieldName,
  dataTest,
  disabled,
  className,
  label,
  rules,
  sliderLabel = label,
  colorTypeOff = 'info',
  colorTypeOn = 'secondary-black',
  size = 'xs'
}) => {
  const {
    field: { ref, ...restField },
    fieldState: { error }
  } = useController({
    name: fieldName,
    control,
    rules
  })

  return (
    <InputGroup
      label={label}
      className={cn('form-input-group', className)}
      labelProps={{ icon: isRequired(rules) && label ? 'asterisk' : undefined }}
      validation={{
        message: error?.message,
        ...(error && { type: 'error' })
      }}
    >
      <Slider
        data-test={dataTest}
        colorTypeOff={colorTypeOff}
        colorTypeOn={colorTypeOn}
        size={size}
        label={sliderLabel}
        checked={restField.value}
        disabled={disabled}
        {...restField}
      />
    </InputGroup>
  )
}

export default FormSlider
